import { render, staticRenderFns } from "./couponType.vue?vue&type=template&id=34b1fad3&"
import script from "./couponType.vue?vue&type=script&lang=js&"
export * from "./couponType.vue?vue&type=script&lang=js&"
import style0 from "./couponType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports